import { FC, memo } from 'react';
import { Nullable, Project, Competition } from '@brg/api';
import ProjectCardNew from '../../../shared/components/projectCard/projectCardNew';
import { BookCard } from '../../../_deziiign/books/core/components/bookCard';
import { computeProject } from '../../../shared/helpers/types/computed/ComputedProject';
import { CreateLinkTo } from '../../../shared/constants/linkTo';
import { computeBook, computeBookProject } from '../../../_deziiign/books/core/components/helper/types/computed/ComputedBook';
import { bProject } from '../../utils';
import { ProjectDelegate } from 'project-delegate';
import { useProfile, bProfile } from '@brg/auth';
import { useModal } from '../../modules';
import { AppTester } from "supporting";
import { TOwnerRights } from '../../../shared/pages/exploreHseContextsNew/exploreHseContextsNew';
import { RingPositions } from '../../../shared/constants/ringPositionType';
import { Placement } from '../../../shared/components/tooltips';
import { BookDelegate } from '../../../_deziiign/books/core/book-delegate';

interface ProjectCardItemProps {
  project: Nullable<Partial<Project<'Local'>>>;
  selectable?: boolean;
  unselectable?: boolean;
  selected?: boolean;
  onSelect?: (projectId: string) => void;
  modal?: boolean;
  withoutGoToProject?: boolean;
  withoutRepost?: boolean;
  linkPrefix?: string;
  isMoreVisible?: boolean;
  isSelectRightNeed?: boolean;
  selectRingPosition?: RingPositions;
  itemType?: string;
  entityType?: string;
  metaAlwaysVisible?: boolean;
  alreadyProject?: boolean;
  showCompetitionPoint?: boolean;
  showCompetitionJuryPoint?: boolean;
  showFirstCompetitionPoint?: boolean;
  currentCompetitionId?: string;
  canMakeImageForTeam?: TOwnerRights;
  noPresentation?: boolean;
  competition?: Competition<'Local'>;
  onShouldReload?: () => void;
  onUpdate?: () => void;
  placement?: Placement;
  isChannel?: boolean;
  isParticipant?: boolean;
  checkBookPaid?: boolean;
  showAnnotations?: boolean;
  isOneColumn?: boolean;
  isExport?: boolean;
  isOuterOrganizationShowcase?: boolean;
}

export const ProjectCardItem: FC<ProjectCardItemProps> = memo(({
  project,
  selectable = false,
  unselectable,
  selected = false,
  onSelect = () => undefined,
  modal = false,
  withoutGoToProject,
  withoutRepost,
  linkPrefix,
  isMoreVisible,
  isSelectRightNeed,
  selectRingPosition,
  itemType,
  metaAlwaysVisible = false,
  alreadyProject = false,
  showCompetitionPoint,
  showCompetitionJuryPoint,
  showFirstCompetitionPoint,
  currentCompetitionId,
  canMakeImageForTeam,
  noPresentation,
  competition,
  onShouldReload,
  onUpdate,
  placement,
  isChannel,
  isParticipant,
  entityType,
  checkBookPaid,
  showAnnotations,
  isOneColumn,
  isExport,
  isOuterOrganizationShowcase,
}) => {
  const designer = useProfile();
  const { show } = useModal();
  const isAgeyTomesh = AppTester.isAgeytomesh();

  if (!project) {
    return null;
  }

  /**
  * Нурс попоросил убрать проект с онлайнс
  */
  if (AppTester.isOnlines() && project?.projectId === "b1e7ff644881488c9d90508feb43aaec") {
    return null;
  }

  if (project.isBook) {
    const book = computeBookProject(project);
    return (
      <BookCard
        {...(computeBook(book) as any)}
        book={book as any}
        key={book?.bookId}
        withoutRepost={withoutRepost}
        onShouldReload={onShouldReload}
        isSelectable={selectable}
        selected={selected}
        alreadyProject={alreadyProject}
        onSelect={onSelect}
        metaAlwaysVisible={metaAlwaysVisible}
        itemType={itemType}
        showCompetitionPoint={showCompetitionPoint}
        showCompetitionJuryPoint={showCompetitionJuryPoint}
        currentCompetitionId={currentCompetitionId}
        showFirstCompetitionPoint={showFirstCompetitionPoint}
        linkPrefix={linkPrefix ? linkPrefix : undefined}
        isChannel={isChannel}
        isParticipant={isParticipant}
        entityType={entityType}
      />
    );
  }

  const handleProjectClick = modal
    ? (projectId?: string, e?: any) => {
        e?.stopPropagation();
        e?.preventDefault();
        if (!project.isBook && projectId) {
          const url = CreateLinkTo.projectNew(project as any);
          if (url) window.open(url, '_blank');
        }
      }
    : undefined;

  return (
    <ProjectCardNew
      {...({
        project: project as any,
        isModal: modal,
        withoutRepost,
        withoutGoToProject,
        onProjectClick: handleProjectClick,
        isSelectable: selectable,
        isUnselectable: unselectable,
        selectRingPosition,
        itemType,
        isEditable:
          !isAgeyTomesh &&
          ((project && designer && bProject?.isEditableFor(project as any, designer)) ||
          bProfile.isModer(designer as any) || bProfile.isMiddleModer(designer as any)) &&
          (!checkBookPaid || !BookDelegate?.isPaid(project as any)),
        isRejected: ProjectDelegate.isRejectedProject(project as any),
        ...computeProject(project as any),
        onShouldReload,
        onUpdate,
        onSelect,
        metaAlwaysVisible,
        selected,
        alreadyProject,
        linkPrefix: linkPrefix ? linkPrefix : undefined,
        isSelectRightNeed,
        showCompetitionPoint,
        showCompetitionJuryPoint,
        currentCompetitionId,
        showFirstCompetitionPoint,
        canMakeImageForTeam,
        competition,
        placement,
        isChannel,
        isParticipant,
        entityType,
        showAnnotations,
        isExport,
        isOuterOrganizationShowcase,
      } as any)}
      isOneColumn={isOneColumn}
      key={project?.projectId}
    />
  );
});
import { FC, memo } from 'react';
import { Nullable, Project, Competition } from '@brg/api';
import ProjectCardNew from '../../../shared/components/projectCard/projectCardNew';
import { BookCard } from '../../../_deziiign/books/core/components/bookCard';
import { computeProject } from '../../../shared/helpers/types/computed/ComputedProject';
import { CreateLinkTo } from '../../../shared/constants/linkTo';
import { computeBook, computeBookProject } from '../../../_deziiign/books/core/components/helper/types/computed/ComputedBook';
import { bProject } from '../../utils';
import { ProjectDelegate } from 'project-delegate';
import { useProfile, bProfile } from '@brg/auth';
import { useModal } from '../../modules';
import { AppTester } from "supporting";
import { TOwnerRights } from '../../../shared/pages/exploreHseContextsNew/exploreHseContextsNew';
import { RingPositions } from '../../../shared/constants/ringPositionType';
import { Placement } from '../../../shared/components/tooltips';
import { BookDelegate } from '../../../_deziiign/books/core/book-delegate';

interface ProjectCardItemProps {
  project: Nullable<Partial<Project<'Local'>>>;
  selectable?: boolean;
  unselectable?: boolean;
  selected?: boolean;
  onSelect?: (projectId: string) => void;
  modal?: boolean;
  withoutGoToProject?: boolean;
  withoutRepost?: boolean;
  linkPrefix?: string;
  isMoreVisible?: boolean;
  isSelectRightNeed?: boolean;
  selectRingPosition?: RingPositions;
  itemType?: string;
  entityType?: string;
  metaAlwaysVisible?: boolean;
  alreadyProject?: boolean;
  showCompetitionPoint?: boolean;
  showCompetitionJuryPoint?: boolean;
  showFirstCompetitionPoint?: boolean;
  currentCompetitionId?: string;
  canMakeImageForTeam?: TOwnerRights;
  noPresentation?: boolean;
  competition?: Competition<'Local'>;
  onShouldReload?: () => void;
  onUpdate?: () => void;
  placement?: Placement;
  isChannel?: boolean;
  isParticipant?: boolean;
  checkBookPaid?: boolean;
  showAnnotations?: boolean;
  isOneColumn?: boolean;
  isExport?: boolean;
  isOuterOrganizationShowcase?: boolean;
}

export const ProjectCardItem: FC<ProjectCardItemProps> = memo(({
  project,
  selectable = false,
  unselectable,
  selected = false,
  onSelect = () => undefined,
  modal = false,
  withoutGoToProject,
  withoutRepost,
  linkPrefix,
  isMoreVisible,
  isSelectRightNeed,
  selectRingPosition,
  itemType,
  metaAlwaysVisible = false,
  alreadyProject = false,
  showCompetitionPoint,
  showCompetitionJuryPoint,
  showFirstCompetitionPoint,
  currentCompetitionId,
  canMakeImageForTeam,
  noPresentation,
  competition,
  onShouldReload,
  onUpdate,
  placement,
  isChannel,
  isParticipant,
  entityType,
  checkBookPaid,
  showAnnotations,
  isOneColumn,
  isExport,
  isOuterOrganizationShowcase,
}) => {
  const designer = useProfile();
  const { show } = useModal();
  const isAgeyTomesh = AppTester.isAgeytomesh();

  if (!project) {
    return null;
  }

  /**
  * Нурс попоросил убрать проект с онлайнс
  */
  if (AppTester.isOnlines() && project?.projectId === "b1e7ff644881488c9d90508feb43aaec") {
    return null;
  }

  if (project.isBook) {
    const book = computeBookProject(project);
    return (
      <BookCard
        {...(computeBook(book) as any)}
        book={book as any}
        key={book?.bookId}
        withoutRepost={withoutRepost}
        onShouldReload={onShouldReload}
        isSelectable={selectable}
        selected={selected}
        alreadyProject={alreadyProject}
        onSelect={onSelect}
        metaAlwaysVisible={metaAlwaysVisible}
        itemType={itemType}
        showCompetitionPoint={showCompetitionPoint}
        showCompetitionJuryPoint={showCompetitionJuryPoint}
        currentCompetitionId={currentCompetitionId}
        showFirstCompetitionPoint={showFirstCompetitionPoint}
        linkPrefix={linkPrefix ? linkPrefix : undefined}
        isChannel={isChannel}
        isParticipant={isParticipant}
        entityType={entityType}
      />
    );
  }

  const handleProjectClick = modal
    ? (projectId?: string, e?: any) => {
        e?.stopPropagation();
        e?.preventDefault();
        if (!project.isBook && projectId) {
          const url = CreateLinkTo.projectNew(project as any);
          if (url) window.open(url, '_blank');
        }
      }
    : undefined;

  return (
    <ProjectCardNew
      {...({
        project: project as any,
        isModal: modal,
        withoutRepost,
        withoutGoToProject,
        onProjectClick: handleProjectClick,
        isSelectable: selectable,
        isUnselectable: unselectable,
        selectRingPosition,
        itemType,
        isEditable:
          !isAgeyTomesh &&
          ((project && designer && bProject?.isEditableFor(project as any, designer)) ||
          bProfile.isModer(designer as any) || bProfile.isMiddleModer(designer as any)) &&
          (!checkBookPaid || !BookDelegate?.isPaid(project as any)),
        isRejected: ProjectDelegate.isRejectedProject(project as any),
        ...computeProject(project as any),
        onShouldReload,
        onUpdate,
        onSelect,
        metaAlwaysVisible,
        selected,
        alreadyProject,
        linkPrefix: linkPrefix ? linkPrefix : undefined,
        isSelectRightNeed,
        showCompetitionPoint,
        showCompetitionJuryPoint,
        currentCompetitionId,
        showFirstCompetitionPoint,
        canMakeImageForTeam,
        competition,
        placement,
        isChannel,
        isParticipant,
        entityType,
        showAnnotations,
        isExport,
        isOuterOrganizationShowcase,
      } as any)}
      isOneColumn={isOneColumn}
      key={project?.projectId}
    />
  );
});
